export default __webpack_public_path__ + "static/media/keidar2.95ee0f3c.jpg";